var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderGrayS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3110",
    "data-name": "Rectangle 3110",
    width: 20,
    height: 20,
    transform: "translate(905 364)",
    fill: "#8a8a8a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_103",
    "data-name": "Mask Group 103",
    transform: "translate(-905 -364)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(905.714 364.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M4.714,4.286H19a2.143,2.143,0,0,1,2.143,2.143V19.286A2.143,2.143,0,0,1,19,21.429H4.714a2.143,2.143,0,0,1-2.143-2.143V6.429A2.143,2.143,0,0,1,4.714,4.286Z",
    transform: "translate(-2.571 -2.857)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinejoin: "round",
    strokeWidth: 1.714
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M18.189,4.286H5.526a2.981,2.981,0,0,0-2.954,3V10h.714A1.536,1.536,0,0,1,4.714,8.571H19A1.536,1.536,0,0,1,20.429,10h.714V7.286a2.981,2.981,0,0,0-2.954-3Z",
    transform: "translate(-2.571 -2.857)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M16.714,12.22a1.072,1.072,0,1,1-1.071-1.046A1.072,1.072,0,0,1,16.714,12.22Z",
    transform: "translate(-4.571 -4.005)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M21,12.22a1.072,1.072,0,1,1-1.071-1.046A1.072,1.072,0,0,1,21,12.22Z",
    transform: "translate(-5.286 -4.005)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M16.714,16.506a1.072,1.072,0,1,1-1.071-1.046A1.072,1.072,0,0,1,16.714,16.506Z",
    transform: "translate(-4.571 -4.72)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M21,16.506a1.072,1.072,0,1,1-1.071-1.046A1.072,1.072,0,0,1,21,16.506Z",
    transform: "translate(-5.286 -4.72)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M8.143,16.506A1.072,1.072,0,1,1,7.071,15.46,1.072,1.072,0,0,1,8.143,16.506Z",
    transform: "translate(-3.143 -4.72)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M12.429,16.506a1.072,1.072,0,1,1-1.071-1.046A1.072,1.072,0,0,1,12.429,16.506Z",
    transform: "translate(-3.857 -4.719)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M8.143,20.791a1.072,1.072,0,1,1-1.071-1.046A1.072,1.072,0,0,1,8.143,20.791Z",
    transform: "translate(-3.143 -5.434)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M12.429,20.791a1.072,1.072,0,1,1-1.071-1.046A1.072,1.072,0,0,1,12.429,20.791Z",
    transform: "translate(-3.857 -5.434)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M16.714,20.791a1.072,1.072,0,1,1-1.071-1.046A1.072,1.072,0,0,1,16.714,20.791Z",
    transform: "translate(-4.571 -5.434)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M6.857,2.571V4",
    transform: "translate(-3.286 -2.571)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M20.571,2.571V4",
    transform: "translate(-5.571 -2.571)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderGrayS);
export default __webpack_public_path__ + "static/media/calender_gray_s.5bf344d181b242646af23413719192fb.svg";
export { ForwardRef as ReactComponent };